import React from 'react';
import AppBarBase from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';

import { IconButton as ICB } from 'gatsby-theme-material-ui';
import Container from '@mui/material/Container';
import PropTypes from 'prop-types';
import { HeaderMenuMain } from './headerMenuMain';
import { ProfileMenu } from './profileMenu';
import MenuIcon from '@mui/icons-material/Menu';
import Stack from '@mui/material/Stack';
import CloseIcon from '@mui/icons-material/Close';
import { ComparisonContext } from '../../../contexts/comparison';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { IconButton } from 'gatsby-theme-material-ui';
import { useLanguageLink } from '../../hooks/useLanguageLink';

const AppBar = ({ onToggleDrawer, headerMenuItems, userProfile, siteHeaderImage, closeUrl }) => {
  const { compareConfig } = React.useContext(ComparisonContext);
  const l = useLanguageLink();

  return (
    <AppBarBase elevation={0} position="static" color={'appBar'}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }}>
            {siteHeaderImage}
          </Box>

          {onToggleDrawer ? (
            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="Toggle for DrawerContent Menu"
                onClick={onToggleDrawer}
                color="appBar.contrastText">
                <MenuIcon sx={{ color: 'appBar.contrastText' }} />
              </IconButton>
            </Box>
          ) : null}
          <Box
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none'
            }}>
            {siteHeaderImage}
          </Box>

          <Stack
            direction={'row'}
            sx={{
              flexGrow: 1,
              display: { xs: 'none', md: 'flex' },
              mr: '3',
              justifyContent: 'end'
            }}>
            {headerMenuItems?.length ? <HeaderMenuMain entries={headerMenuItems} /> : null}
          </Stack>
          {closeUrl ? (
            <Box sx={{ flexGrow: 0, zIndex: 10000, color: 'appBar.contrastText' }}>
              <ICB to={closeUrl} title="Close">
                <CloseIcon sx={{ color: 'appBar.contrastText' }} />
              </ICB>
            </Box>
          ) : null}
          {(userProfile && <ProfileMenu
            userProfile={userProfile} />) || ((compareConfig?.models?.filter(m=>m)?.length>0 || compareConfig?.trimLevels?.filter(m=>m)?.length>0) && <IconButton sx={{ border:'1px solid' }} to={l('/compare/')} color={'primary'}  ><FavoriteIcon /></IconButton>) || <Box sx={{ width:48 }}></Box>}
        </Toolbar>
      </Container>
    </AppBarBase>
  );

};
AppBar.propTypes = {
  closeUrl: PropTypes.string,
  siteHeaderImage: PropTypes.node,
  headerMenuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      linkText: PropTypes.string.isRequired,
      linkTitle: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  ),
  userProfile: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    profilePicture: PropTypes.string.isRequired,
    signOut: PropTypes.func.isRequired,
    settings: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      linkText: PropTypes.string.isRequired,
      linkTitle: PropTypes.string.isRequired
    }))
  }),
  onToggleDrawer: PropTypes.func
};

export default AppBar;
export { AppBar };
